import { BoxedRow, ButtonPrimary, Divider, BoxedRowList } from '@telefonica/mistica';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { globalEvents, triggerGlobalEvent } from '../../../../../utils/dataTransformation/GlobalEvents';
import { useBillsContext } from '../../../../../context/bills-context/BillsContext';
import HeaderComponent from '../../../../../components/HeaderComponent';

const InvoiceManagement = () => {
    const navigate = useNavigate();
    const { bill } = useBillsContext();

    const navigationBackHandler = () => navigate(`/bills/bill-detail?id=${bill.id}`);

    return (
        <div className='claimOpening'>
            <HeaderComponent
                title={t('breadcrumbsTitleClaimOpening')}
                navigationBarOnBack={navigationBackHandler}
                breadcrumbs={[
                    { title: t('invoice'), url: '/bills' },
                    { title: t('breadcrumbsTitleBillDetail'), url: `/bills/bill-detail?id=${bill.id}` },
                ]}
            />

            <div className='claimOpening__content'>
                <BoxedRowList>
                    <BoxedRow
                        title={t('claimOpeningCardTitlequestions')}
                        description={t('claimQuestionsDescription')}
                        extra={
                            <div className='claimOpening__content-btn'>
                                <ButtonPrimary
                                    small
                                    onPress={() => {
                                        window.open('https://o2online.es/ayuda/facturacion/', '_blank');
                                    }}
                                >
                                    {t('consult')}
                                </ButtonPrimary>
                            </div>
                        }
                    />

                    <BoxedRow
                        title={t('changeQuota')}
                        description={t('changeQuotaDescription')}
                        extra={
                            <div className='claimOpening__content-btn'>
                                <ButtonPrimary small onPress={() => triggerGlobalEvent(globalEvents.changeQuota)}>
                                    {t('changeQuotaButton')}
                                </ButtonPrimary>
                            </div>
                        }
                    />

                    <BoxedRow
                        title={t('claimOpeningCardTitledispute')}
                        description={t('claimDisputeDescription')}
                        extra={
                            <div className='claimOpening__content-btn'>
                                <ButtonPrimary small onPress={() => navigate('/claims/claim-type')}>
                                    {t('openClaimButton')}
                                </ButtonPrimary>
                            </div>
                        }
                    />
                </BoxedRowList>
            </div>
        </div>
    );
};

export default InvoiceManagement;
